import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bubble", "menu", "badge"]

  connect() {
    // Close dropdown when clicking outside
    this.boundClickOutside = this.clickOutside.bind(this)
    // Close dropdown on Escape key
    this.boundHandleEscape = this.handleEscape.bind(this)

    // Store initial badge count
    this.previousBadgeCount = this.getCurrentBadgeCount()

    // Listen for Turbo Stream updates
    this.boundHandleTurboStream = this.handleTurboStreamRender.bind(this)
    document.addEventListener("turbo:before-stream-render", this.boundHandleTurboStream)
  }

  getCurrentBadgeCount() {
    const badgeElement = this.element.querySelector('[data-unread-messages-dropdown-target="badge"]')
    if (!badgeElement) return 0
    const text = badgeElement.textContent.trim()
    if (text === "99+") return 100
    return parseInt(text, 10) || 0
  }

  handleTurboStreamRender(event) {
    // After DOM update, check if badge count changed
    setTimeout(() => {
      const newCount = this.getCurrentBadgeCount()
      if (newCount > this.previousBadgeCount && this.previousBadgeCount > 0) {
        this.playNotificationSound()
      }
      this.previousBadgeCount = newCount
    }, 100)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.boundHandleTurboStream)
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.menuTarget.classList.add("animate-fadeIn")
    document.addEventListener("click", this.boundClickOutside)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.menuTarget.classList.remove("animate-fadeIn")
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  playNotificationSound() {
    // Create a simple notification sound using Web Audio API
    // This creates a pleasant "ding" sound
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)()
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()

      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)

      // Pleasant notification tone (E5 note, 659.25 Hz)
      oscillator.frequency.setValueAtTime(659.25, audioContext.currentTime)
      oscillator.type = "sine"

      // Envelope: quick attack, short sustain, quick release
      gainNode.gain.setValueAtTime(0, audioContext.currentTime)
      gainNode.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.01)
      gainNode.gain.linearRampToValueAtTime(0.2, audioContext.currentTime + 0.1)
      gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.3)

      oscillator.start(audioContext.currentTime)
      oscillator.stop(audioContext.currentTime + 0.3)
    } catch (error) {
      // Silently fail if audio context is not available
    }
  }
}
